import {
  SET_LAST_UPDATE_TIME,
  SET_USER_INFO,
  SET_MENU_STATUS,
  SET_DEVICE_SIZE,
  SET_LANGUAGE,
  SET_LANGUAGE_OBJ,
  SET_DEVICE_INFO,
  SET_RF_PATH
} from '../actionTypes/commonTypes'
import { Base64 } from '../../utils/base64'
const getVal = (key, empty) => {
  let res = ''
  try {
    res = (localStorage.getItem(key) && JSON.parse(Base64.decode(localStorage.getItem(key)))) || empty
  } catch (error) {
    res = empty
  }
  return res
}
let lang = 'zh_CN'
if (localStorage.getItem('language') === 'zh_CN' || localStorage.getItem('language') === 'en_US') {
  // 防止莫名出现其他值
  lang = localStorage.getItem('language')
}
const initState = {
  lastUpdateTime: '',
  account: localStorage.getItem('account') || '',
  userName: localStorage.getItem('userName') || '',
  permissionsCompleteInfo: getVal('permissionsCompleteInfo', []),
  permissions: getVal('permissions', []),
  roles: getVal('roles', []),
  categorys: getVal('categorys', []),
  workstation: getVal('workstation', ''),
  mac: getVal('mac', ''),
  partUserInfo: getVal('partUserInfo', {}),
  deviceCode: getVal('deviceCode', ''),
  functionModule: getVal('functionModule', ''),
  rfPath: getVal('rfPath', ''),
  deviceSize: 1920 / 1280,
  language: lang,
  languageObj: {}
}
const commonReducer = (state = initState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_MENU_STATUS:
      return {
        ...state,
        isMenuShow: payload
      }
    case SET_LAST_UPDATE_TIME:
      return {
        ...state,
        lastUpdateTime: payload
      }
    case SET_USER_INFO:
      return {
        ...state,
        userName: payload.userName,
        account: payload.account,
        permissions: JSON.parse(payload.permissions),
        permissionsCompleteInfo: JSON.parse(payload.permissionsCompleteInfo),
        roles: JSON.parse(payload.roles),
        categorys: JSON.parse(payload.categorys),
        workstation: JSON.parse(payload.workstation),
        mac: JSON.parse(payload.mac),
        partUserInfo: JSON.parse(payload.partUserInfo)
      }
    case SET_DEVICE_SIZE:
      return {
        ...state,
        deviceSize: payload
      }
    case SET_LANGUAGE:
      return {
        ...state,
        language: payload
      }
    case SET_LANGUAGE_OBJ:
      return {
        ...state,
        languageObj: payload
      }
    case SET_DEVICE_INFO:
      return {
        ...state,
        mac: JSON.parse(payload.mac),
        deviceCode: JSON.parse(payload.deviceCode),
        functionModule: JSON.parse(payload.functionModule)
      }
    case SET_RF_PATH:
      return {
        ...state,
        rfPath: JSON.parse(payload.rfPath)
      }
    default:
      return {
        ...state
      }
  }
}

export default commonReducer
